const formatCareplanSection = (title, fields) => {
  const lines = fields.filter((field) => field.value).map((field) => `${field.label}: ${field.value}`);

  if (lines.length === 0) {
    return '';
  }

  return `${title}\n${lines.join('\n')}`;
};

const formatCareplanResponse = (result) => {
  const generalInformation = result.generalInformation || {};
  const medicalHistory = result.medicalHistory || {};
  const careRoutine = result.careRoutine || {};
  const caregiverRequirements = result.caregiverRequirements || {};

  return [
    formatCareplanSection('General Information', [
      {label: 'Client Name', value: generalInformation.clientName},
      {label: 'Address', value: generalInformation.address},
      {label: 'Client Info', value: generalInformation.clientInfo},
      {label: 'Notes', value: generalInformation.notes},
    ]),
    formatCareplanSection('Medical History', [
      {label: 'Medications', value: medicalHistory.medications},
      {label: 'Conditions', value: medicalHistory.conditions},
    ]),
    formatCareplanSection('Care Routine', [
      {label: 'Client Preferences', value: careRoutine.clientPreferences},
      {label: 'Daily Tasks', value: careRoutine.dailyTasks},
    ]),
    formatCareplanSection('Caregiver Requirements', [
      {label: 'Careplan Summary', value: caregiverRequirements.careplanSummary},
      {label: 'Schedule Requirement', value: caregiverRequirements.scheduleRequirement},
      {label: 'Match Difficulty', value: caregiverRequirements.matchDifficulty},
      {
        label: 'Requirement Chips',
        value: caregiverRequirements.caregiverRequirementChips?.join(', '),
      },
    ]),
  ].filter(Boolean).join('\n\n');
};

const formatTestResponse = (testResponse) => {
  const result = testResponse?.result;

  if (!result) {
    return '';
  }

  switch (result.outputType) {
    case 'EMAIL':
      return result.content || '';
    case 'SMS':
      return result.message || '';
    case 'TEXT':
      return result.text || '';
    case 'CAREPLAN':
      return formatCareplanResponse(result);
    default:
      return '';
  }
};

export default formatTestResponse;
